import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'features/common/MaterialBasedComponents';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import validation from '../../utils/validation';
import { folderModalActions } from './enums';
import T from 'i18n';
import InfoRow from 'features/common/InfoRow';
import moment from 'moment';
import { useGetMoreInfoFolder } from './redux/hooks';
import Spinner from 'features/common/Spinner';
import { SelectForm, TextForm, ToggleForm } from 'features/common';
import DateInput from 'features/common/FormControls/DateInput';
import TimeInput from 'features/common/FormControls/TimeInput';
import { useSelector } from 'react-redux';
import {
  selectContainers,
  selectCurrentCase,
  selectCurrentCaseTeamId,
  selectCustomContainers,
  selectFolderContainers,
  selectFolders,
  selectGlobalPagingTrialbooks,
  selectIsAdmin,
  selectPermissions,
  selectPipelineVersion,
  selectReferencePrefix,
  selectUserSettings,
  selectAllowDeleteAll,
  selectDocuments,
} from 'common/selectors';
import { formatLabel } from 'utils/formatLabel';
import Row from 'react-bootstrap/Row';
import { Col } from 'react-bootstrap';
import { CollapsibleActivityLogs } from 'features/common/ActivityLogs';
import { findIndexOfDeepNestedFolder } from 'utils/arrays';
import FilterProvider from './TableCase/FilterProvider';
import HealthCheckModal from './HealthCheckModal';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Grid,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Select as MuiSelect,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  Switch,
  FormControlLabel,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useGetFolderStats } from './redux/getFolderStats';
import { bytesToMegaBytes } from 'utils/formating';
import debounce from 'utils/debounce';
import { useDispatch } from 'react-redux';
import { fetchGroups } from './redux/fetchGroups';
import saveAs from 'save-as';
import RepositionModal from './RepositionModal';
import AssignFilesFromCSV from './TableWrapper/AssignFilesFromCSV';
import NewReindexContent from './FolderModal/ReindexContent/NewReindex';
import ClassifyContent from './FolderModal/ClassifyContent';

const getTitles = (action) => {
  switch (action) {
    case folderModalActions.moveToTrialBooks:
      return {
        title: 'case.moveABundleTitle',
        saveTitle: 'generic.move',
        message: 'case.moveABundleMessage',
        containerType: 'bundle',
        toContainerName: 'Trial Bundles',
      };
    case folderModalActions.removeFromTrialBooks:
      return {
        title: 'case.removeABundleTitle',
        saveTitle: 'generic.remove',
        message: 'case.removeABundleMessage',
        containerType: 'bundle',
        toContainerName: 'Trial Bundles',
      };
    case folderModalActions.moveToCourtBundles:
      return {
        title: 'case.moveABundleTitle',
        saveTitle: 'generic.move',
        message: 'case.moveABundleMessage',
        containerType: 'bundle',
        toContainerName: 'Court Bundles',
      };
    case folderModalActions.removeFromCourtBundles:
      return {
        title: 'case.removeABundleTitle',
        saveTitle: 'generic.remove',
        message: 'case.removeABundleMessage',
        containerType: 'bundle',
        toContainerName: 'Court Bundles',
      };
    case folderModalActions.updateBundle:
      return {
        title: 'case.bundleSettings',
        saveTitle: 'generic.update',
        containerType: 'bundle',
      };
    case folderModalActions.createPrivateBundle:
    case folderModalActions.createTeamBundle:
    case folderModalActions.createBundle:
      return {
        title: 'case.addABundleTitle',
        saveTitle: 'generic.create',
        containerType: 'bundle',
      };
    case folderModalActions.deleteBundle:
      return {
        title: 'case.deleteABundleTitle',
        saveTitle: 'generic.delete',
        message: 'case.deleteABundleMessage',
        containerType: 'bundle',
      };
    case folderModalActions.share:
      return {
        title: 'case.shareABundleTitle',
        saveTitle: 'generic.share',
        message: 'case.shareABundleMessage',
        containerType: 'bundle',
      };
    case folderModalActions.createTrialbook:
      return {
        title: 'case.addATrialbookTitle',
        saveTitle: 'generic.create',
        containerType: 'trialbook',
      };
    case folderModalActions.agreeTrialbook:
      return {
        title: 'case.agreeTrialbookTitle',
        saveTitle: 'generic.confirm',
        message: 'case.agreeTrialbookMessage',
        containerType: 'trialbook',
      };
    case folderModalActions.updateTrialbook:
      return {
        title: 'case.bundleSettings',
        saveTitle: 'generic.update',
        containerType: 'trialbook',
      };
    case folderModalActions.deleteTrialbook:
      return {
        title: 'case.deleteTrialbook',
        saveTitle: 'generic.delete',
        message: 'case.deleteTrialbookMessage',
        containerType: 'trialbook',
      };
    case folderModalActions.showHistory:
      return {
        title: 'case.showHistory',
        message: 'case.showHistoryMessage',
      };
    case folderModalActions.createTimeline:
      return {
        title: 'case.createTimeline',
        saveTitle: 'generic.create',
        containerType: 'timeline',
      };
    case folderModalActions.updateTimeline:
      return {
        title: 'generic.update',
        saveTitle: 'generic.update',
        containerType: 'timeline',
      };
    case folderModalActions.deleteTimeline:
      return {
        title: 'generic.delete',
        saveTitle: 'generic.delete',
        message: 'case.deleteTimelineMessage',
        containerType: 'timeline',
      };
    case folderModalActions.createTag:
      return {
        title: 'generic.createTag',
        saveTitle: 'generic.create',
        containerType: 'tags',
      };
    case folderModalActions.updateTag:
      return {
        title: 'generic.update',
        saveTitle: 'generic.update',
        containerType: 'tags',
      };
    case folderModalActions.deleteTag:
      return {
        title: 'generic.delete',
        saveTitle: 'generic.delete',
        message: 'case.deleteTagMessage',
        containerType: 'tag',
      };
    case folderModalActions.burnCrossRef:
      return {
        title: 'case.saveCrossRefMsg',
        saveTitle: 'generic.burn',
        message: 'case.burnCrossRefMessage',
      };
    case folderModalActions.reIndex:
      return {
        title: 'generic.reIndex',
        saveTitle: 'generic.reIndex',
        message: 'case.reIndexMessage',
      };
    case folderModalActions.classify:
      return {
        title: 'generic.classify',
        saveTitle: 'generic.classify',
        message: 'case.classifyMessage',
      };
    case folderModalActions.healthCheck:
      return {
        title: 'generic.healthCheckTitle',
      };
    case folderModalActions.exportTimeline:
      return {
        title: 'case.exportTimeline',
        saveTitle: 'generic.export',
        message: 'case.exportTimelineMessage',
      };
    case folderModalActions.exportFolder:
      return {
        title: 'case.exportFolder',
        saveTitle: 'generic.export',
      };
    case folderModalActions.downloadFolder:
      return {
        title: 'case.downloadFolder',
        saveTitle: 'generic.download',
        message: 'case.downloadFolderMessage',
      };
    case folderModalActions.deleteAll:
      return {
        title: 'case.deleteAllTitle',
        saveTitle: 'generic.delete',
        message: 'case.deleteAllMessage',
      };
    case folderModalActions.clone:
      return {
        title: 'case.clone',
        saveTitle: 'generic.clone',
        message: '',
      };
    case folderModalActions.convertToBundle:
      return {
        title: 'case.convertToBundle',
        saveTitle: 'case.convertToBundle',
        message: '',
      };
    case folderModalActions.unlock:
      return {
        title: 'case.unlock',
        saveTitle: 'case.unlock',
        message: '',
      };
    case folderModalActions.shareWithGroup:
      return {
        title: 'case.moveToGroupBundles',
        saveTitle: 'generic.move',
        message: 'case.shareWithGroupMessage',
      };
    case folderModalActions.removeFromGroupBundles:
      return {
        title: 'case.removeFromGroupBundles',
        saveTitle: 'generic.remove',
        message: 'case.removeFromGroupBundlesMessage',
        containerName: 'Group Bundles',
      };
    case folderModalActions.bulkUpdateFiles:
      return {
        title: 'generic.bulkUpdateFiles',
        saveTitle: 'generic.update',
      };
    case folderModalActions.updateExhibitNumbers:
      return {
        title: 'generic.updateExhibitNumbers',
        saveTitle: 'generic.update',
      };
    default:
      return {};
  }
};

const HistoryInfo = ({
  createdBy,
  lastEditedBy,
  publishedBy,
  pending,
  data,
  fileCount = 0,
  folder,
}) => {
  const { folderStats, getFolderStats, getFolderStatsPending } = useGetFolderStats();
  const [loading, setLoading] = useState(getFolderStatsPending);
  useEffect(() => {
    getFolderStats({ folderId: folder.id });
  }, [folder, getFolderStats]);

  useEffect(() => {
    if (getFolderStatsPending) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [getFolderStatsPending]);

  return (
    <div style={{ padding: '2rem', paddingBottom: 0 }}>
      {createdBy && (
        <>
          <InfoRow field={createdBy.name} title={'case.createdByName'} />
          <InfoRow
            field={moment.utc(createdBy.date).local().format('DD/MM/YYYY HH:mm')}
            title={'case.createdByDate'}
          />
        </>
      )}
      {lastEditedBy && (
        <>
          <InfoRow field={lastEditedBy.name} title={'case.lastEditedByName'} />
          <InfoRow
            field={moment(lastEditedBy.date).utc().format('DD/MM/YYYY HH:mm')}
            title={'case.lastEditedByDate'}
          />
        </>
      )}
      {!loading ? (
        <>
          <InfoRow field={`${folderStats?.fileCount}`} title={'case.historyModal.totalFiles'} />

          <InfoRow
            field={`${bytesToMegaBytes(folderStats?.totalFileSize)}`}
            title={'case.historyModal.totalSize'}
          />

          <InfoRow field={`${folderStats?.pageCount || 0}`} title={'case.historyModal.pageCount'} />

          <InfoRow
            field={`${folderStats?.subFolderCount || 0}`}
            title={'case.historyModal.subFolderCount'}
          />
        </>
      ) : (
        <Spinner style={{ fontSize: '0.5rem' }} />
      )}
      {pending ? (
        <Spinner style={{ fontSize: '0.5rem' }} />
      ) : (
        <CollapsibleActivityLogs
          data={data}
          tableHeight={'25rem'}
          rowHeight={70}
          outsideTableMargin={'0'}
        />
      )}
    </div>
  );
};

const mapping = {
  trialbook: 'trialbooks',
  'court-bundle': 'court-bundles',
  bundle: 'bundles',
  'team-bundle': 'teamBundles',
  'private-bundle': 'privateBundles',
};

const checkGPStatusofParentFolder = (folder, containers) => {
  //checking for only level 1 as GP is allowd at level 0 & 1
  if (
    folder &&
    folder.level === 1 &&
    folder.type !== 'tags' &&
    folder.type !== 'annotations' &&
    folder.type !== 'timelines'
  ) {
    const folderContainer = containers.find((cnt) => cnt.code === mapping[folder.type]);
    const parentFolders = folderContainer['folders'];
    for (let index = 0; index < parentFolders.length; index++) {
      if (findIndexOfDeepNestedFolder(parentFolders[index]['folders'], folder) >= 0) {
        return parentFolders[index].globalPaging;
      }
    }
  }
  return false;
};

const checkGpStatusOfChildFolders = (folders) => {
  if (folders && folders.length > 0) {
    for (let index = 0; index < folders.length; index++) {
      if (folders[index].globalPaging) return true;
    }
  }
  return false;
};

export default function FolderModal({
  show,
  handleClose,
  handleSave,
  action,
  folder,
  isBundleTabPage,
  trialBooksData,
  bundles,
  code,
}) {
  const globalPagingTrialbooks = useSelector(selectGlobalPagingTrialbooks);
  const documents = useSelector(selectDocuments);
  const {
    folders,
    zeroBasedIndex = false,
    generateIndexFolder = false,
    globalPaging = globalPagingTrialbooks,
    globalPagePrefix = '',
    predictiveIndex = false,
    agreed = false,
  } = folder || {};
  const methods = useForm({ mode: 'onChange', reValidateMode: 'onChange' });
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    formState: { errors },
    control,
  } = methods;
  const dispatch = useDispatch();
  const titles = getTitles(action);
  const { moreInfoFolder, getMoreInfoFolder, getMoreInfoFolderPending } = useGetMoreInfoFolder();
  const isCustomContainers = useSelector(selectCustomContainers);
  const containers = useSelector(selectContainers);
  const folderContainers = useSelector(selectFolderContainers);
  const {
    documents: { canAgreeTrialbook, canUnAgreeTrialbook } = {},
    folders: {
      canAddDocuments,
      canBulkUpdateFiles,
      canBulkSetDocDateFromPrimaryDate,
    } = {},
  } = useSelector(selectPermissions);
  const pipelineVersion = useSelector(selectPipelineVersion);
  const [valuesHaveNotBeenSelected, setValuesHaveNotBeenSelected] = useState(true);
  const [reindexConflict, setReindexConflict] = useState(false);
  const [saving, setSaving] = useState(false);

  const isSystemAdmin = useSelector(selectIsAdmin);
  const allowDeleteAll = useSelector(selectAllowDeleteAll);
  const teamId = useSelector(selectCurrentCaseTeamId);
  const {
    trialbooks: allTrialbooks = [],
    teamBundles: allTeamBundles = [],
    privateBundles: allPrivateBundles = [],
  } = useSelector(selectFolders);
  const trialbooks = allTrialbooks.filter((f) => canAddDocuments(f));
  const teamBundles = allTeamBundles.filter((f) => canAddDocuments(f));
  const privateBundles = allPrivateBundles.filter((f) => canAddDocuments(f));
  const [showAssignFilesFromCSV, setShowAssignFilesFromCSV] = useState(false);
  const [showBulkConfirmation, setShowBulkConfirmation] = useState(false);
  const [pendingBulkPayload, setPendingBulkPayload] = useState(null);
  const [fieldMappings, setFieldMappings] = useState({});
  const [copyFromPrimaryDate, setCopyFromPrimaryDate] = useState(false);
  const [clearFields, setClearFields] = useState({});
  const hasFullBulkUpdatePermission = Boolean(canBulkUpdateFiles || isSystemAdmin);
  const hasBulkDocDatePermission = Boolean(canBulkSetDocDateFromPrimaryDate || isSystemAdmin);
  const isBulkDateOnlyMode =
    action === folderModalActions.bulkUpdateFiles &&
    hasBulkDocDatePermission &&
    !hasFullBulkUpdatePermission;

  const copyFromOptions = [
    { value: 'name', label: T.translate('case.copyFromName') },
    { value: 'docDate', label: T.translate('case.copyFromDocDate') },
    { value: 'id', label: T.translate('case.copyFromId') },
    { value: 'trialviewId', label: T.translate('case.copyFromTrialviewId') },
    { value: 'discoveryId', label: T.translate('case.discoveryId') },
    { value: 'externalId', label: T.translate('case.externalId') },
    { value: 'description', label: T.translate('case.description') },
    { value: 'altDate', label: T.translate('case.copyFromAltDate') },
    { value: 'exhibitNumber', label: T.translate('case.copyFromExhibitNumber') },
    { value: 'familyId', label: T.translate('case.familyId') },
    { value: 'disclosureId', label: T.translate('case.disclosureId') },
  ];

  const handleCopyFromChange = (toField, fromField) => {
    setFieldMappings((prev) => {
      if (fromField) {
        return { ...prev, [toField]: fromField };
      }
      const next = { ...prev };
      delete next[toField];
      return next;
    });
  };

  const handleClearFieldToggle = (fieldName, checked) => {
    setClearFields((prev) => ({ ...prev, [fieldName]: checked }));
    if (checked) {
      setValue(fieldName, '');
      handleCopyFromChange(fieldName, '');
    }
  };

  // Watch bulk-update fields to enable save only when at least one is filled
  const watchedDocDate = watch('docDate');
  const watchedDiscoveryId = watch('discoveryId');
  const watchedExternalId = watch('externalId');
  const watchedDisclosureId = watch('disclosureId');
  const watchedFamilyId = watch('familyId');
  const watchedDescription = watch('description');
  const watchedDocTime = watch('docTime');
  const watchedExhibitPrefix = watch('exhibitPrefix');
  const watchedExhibitStartNumber = watch('exhibitStartNumber');
  const overwriteExistingReferences = watch('overwriteExistingReferences', false);
  const isNonEmptyString = (value) =>
    typeof value === 'string' ? value.trim().length > 0 : !!value;

  const hasAnyBulkUpdateField =
    (isBulkDateOnlyMode
      ? [watchedDocDate, watchedDocTime].some(isNonEmptyString) ||
        copyFromPrimaryDate ||
        Boolean(clearFields.docDate)
      :
    [
      watchedDocDate,
      watchedDiscoveryId,
      watchedExternalId,
      watchedDisclosureId,
      watchedFamilyId,
      watchedDescription,
      watchedDocTime,
    ].some(isNonEmptyString) ||
        Object.keys(fieldMappings).length > 0 ||
        copyFromPrimaryDate ||
        Object.values(clearFields).some(Boolean));

  const isBulkDateInvalid =
    action === folderModalActions.bulkUpdateFiles &&
    watchedDocDate &&
    watchedDocDate.trim &&
    !moment(watchedDocDate, 'DD/MM/YYYY', true).isValid();

  const isBulkTimeInvalid =
    action === folderModalActions.bulkUpdateFiles &&
    watchedDocTime &&
    watchedDocTime.trim &&
    !moment(watchedDocTime, 'HH:mm:ss', true).isValid();

  const exhibitPrefixValue =
    typeof watchedExhibitPrefix === 'string' ? watchedExhibitPrefix.trim() : '';
  const isExhibitPrefixValid = /^[A-Z]$/.test(exhibitPrefixValue);
  const isExhibitStartNumberEmpty =
    watchedExhibitStartNumber === '' ||
    watchedExhibitStartNumber === null ||
    typeof watchedExhibitStartNumber === 'undefined';
  const exhibitStartNumberValue = Number(watchedExhibitStartNumber);
  const isExhibitStartNumberValid =
    !isExhibitStartNumberEmpty &&
    Number.isFinite(exhibitStartNumberValue) &&
    exhibitStartNumberValue >= 0;

  const folderCreatedByTeamId = folder && folder.createdBy && folder.createdBy.teamId;
  const folderCreatedByTeamName = folder && folder.createdBy && folder.createdBy.teamName;
  const isAgreeTrialbook =
    (canAgreeTrialbook || isSystemAdmin) && folder && folder.type === 'trialbook';
  const isUnAgreeTrialbook = canUnAgreeTrialbook;
  const canDeleteAllLegacy =
    !folder?.readOnly &&
    folder?.fileCount > 0 &&
    ((folder?.folders && folder.folders.length === 0) || folder?.level === 0);
  const canDeleteAllAllowed = allowDeleteAll ? !folder?.readOnly : canDeleteAllLegacy;
  const isGPEnabledForParentFolders = checkGPStatusofParentFolder(folder, folderContainers);
  const isGPEnabledForChildFolders = checkGpStatusOfChildFolders(folders);
  const enableGP =
    folder && folder.level === 0
      ? !isGPEnabledForChildFolders || (isGPEnabledForChildFolders && folder.globalPaging)
      : folder && folder.level === 1
        ? !isGPEnabledForParentFolders
        : true;

  const [showGlobalPaging, setShowGlobalPaging] = useState(globalPaging);
  const [globalPrefixVal, setGlobalPrefixVal] = useState(globalPagePrefix || '');
  const [showWarning, setShowWarning] = useState(false);
  const [groupOptions, setGroupOptions] = useState(null);
  const [cloneFolderType, setCloneFolderType] = useState('');
  const [cloneOptionType, setCloneOptionType] = useState('');
  const [classifyFolderType, setClassifyFolderType] = useState('');
  const [duplicatePrefixError, setDuplicatePrefixError] = useState('');

  const watchedClassifyType = watch('classifyType');

  const getBooks = (list) =>
    (list || []).map((f) => ({ name: f.name, id: f.id, code: f.code, type: f.type }));

  const getCloneFolderToOptions = (container) => {
    if (container === 'trialbook' && trialbooks.length > 0) {
      return [
        {
          label: 'Trialbooks',
          options: getBooks(trialbooks),
        },
      ];
    } else if (container === 'team-bundle' && teamBundles.length > 0) {
      return [
        {
          label: 'Team Bundles',
          options: getBooks(teamBundles),
        },
      ];
    } else if (container === 'private-bundle' && privateBundles.length > 0) {
      return [
        {
          label: 'Private Bundles',
          options: getBooks(privateBundles),
        },
      ];
    } else return [];
  };

  const checkDuplicatePrefix = useCallback(
    debounce((prefix) => {
      // If prefix is empty, no need to check for duplicates
      if (!prefix) {
        setDuplicatePrefixError('');
        return;
      }

      // Check if current folder is being edited (to exclude its own prefix)
      const currentFolderId = folder?.id;

      // Check if prefix already exists in other bundles
      const duplicateFound =
        trialBooksData &&
        trialBooksData.some(
          (bundle) =>
            // Skip comparing with current bundle if we're editing
            bundle.id !== currentFolderId &&
            bundle.globalPagePrefix &&
            bundle.globalPagePrefix.toUpperCase() === prefix.toUpperCase(),
        );

      if (duplicateFound) {
        setDuplicatePrefixError(T.translate('case.duplicatePrefixErrorMessage'));
      } else {
        setDuplicatePrefixError('');
      }
    }, 400),
    [trialBooksData, folder?.id],
  );

  const getClassifyFolderToOptions = (container) => {
    if (container === 'trialbook' && trialbooks.length > 0) {
      return [
        {
          label: 'Trialbooks',
          options: getBooks(trialbooks),
        },
      ];
    } else if (container === 'team-bundle' && teamBundles.length > 0) {
      return [
        {
          label: 'Team Bundles',
          options: getBooks(teamBundles),
        },
      ];
    } else if (container === 'private-bundle' && privateBundles.length > 0) {
      return [
        {
          label: 'Private Bundles',
          options: getBooks(privateBundles),
        },
      ];
    } else return [];
  };

  const cloneFolderToOptions = getCloneFolderToOptions(cloneFolderType);
  const classifyFolderToOptions = getClassifyFolderToOptions(classifyFolderType);

  const handleWarning = (target) => {
    if (target) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
  };

  useEffect(() => {
    if (action === folderModalActions.assignFilesFromCSV && show) {
      setShowAssignFilesFromCSV(true);
    } else {
      setShowAssignFilesFromCSV(false);
    }
  }, [action, show]);

  useEffect(() => {
    if (action === folderModalActions.shareWithGroup && !groupOptions) {
      dispatch(fetchGroups()).then((res) => {
        setGroupOptions(res.map((g) => ({ name: g.name, id: g.id })));
      });
    }
  }, [action, groupOptions, dispatch, teamId]);

  const executeBulkUpdate = useCallback(
    (payload) => {
      setSaving(true);
      const promise = handleSave(payload, action, folder);
      if (promise && typeof promise.then === 'function') {
        promise
          .then(() => {
            setSaving(false);
            handleClose();
          })
          .catch(() => {
            setSaving(false);
          });
      } else {
        setSaving(false);
        handleClose();
      }
    },
    [handleSave, action, folder, handleClose],
  );

  const handleBulkExportAndUpdate = useCallback(() => {
    setShowBulkConfirmation(false);
    const escapeCsvCell = (value) => {
      if (value == null) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };
    const csvColumns = [
      { key: 'name', header: 'Name' },
      { key: 'docDate', header: 'Date' },
      { key: 'discoveryId', header: 'Discovery Id' },
      { key: 'externalId', header: 'External Id' },
      { key: 'disclosureId', header: 'Disclosure Id' },
      { key: 'familyId', header: 'Family Id' },
      { key: 'description', header: 'Description' },
      { key: 'exhibitNumber', header: 'Exhibit Number' },
      { key: 'notes', header: 'Notes' },
    ];
    const headerRow = csvColumns.map((col) => col.header).join(',');
    const dataRows = documents.map((doc) =>
      csvColumns.map((col) => escapeCsvCell(doc[col.key])).join(','),
    );
    const csvContent = [headerRow, ...dataRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const timeStamp = `${new Date().getFullYear()}-${new Date().getDate()}-${
      new Date().getMonth() + 1
    }--${new Date().getHours()}-${new Date().getMinutes()}-${new Date().getSeconds()}`;
    const fileName = `${folder?.name || 'files'}_${timeStamp}.csv`;
    saveAs(blob, fileName);
    if (pendingBulkPayload) {
      executeBulkUpdate(pendingBulkPayload);
    }
  }, [documents, folder, pendingBulkPayload, executeBulkUpdate]);

  const handleBulkUpdateWithoutExport = useCallback(() => {
    setShowBulkConfirmation(false);
    if (pendingBulkPayload) {
      executeBulkUpdate(pendingBulkPayload);
    }
  }, [pendingBulkPayload, executeBulkUpdate]);

  const referencePrefix = useSelector(selectReferencePrefix);
  useEffect(() => {
    if (action === folderModalActions.showHistory && show) {
      getMoreInfoFolder({ folderId: folder.id });
    }
  }, [action, getMoreInfoFolder, show, folder]);

  const formLabelHandler = () => {
    if (action === folderModalActions.clone) {
      return T.translate('case.cloneFolderName');
    } else if (action === folderModalActions.convertToBundle) {
      return T.translate('case.convertBundleName');
    } else {
      return T.translate('case.bundleName');
    }
  };

  const formPlaceholderHandler = () => {
    if (action === folderModalActions.createTrialbook) {
      return T.translate('case.trialbookPlaceholder');
    } else if (
      action === folderModalActions.createTimeline ||
      action === folderModalActions.updateTimeline
    ) {
      return T.translate('case.timelinePlaceholder');
    } else if (action === folderModalActions.createTag || action === folderModalActions.updateTag) {
      return T.translate('case.createTagPlaceholder');
    }

    return T.translate('case.bundlePlaceholder');
  };

  const handleGlobalPrefixChange = (e) => {
    let value = e.target.value;

    // Always convert to uppercase
    value = value.toUpperCase();

    // If empty, allow it
    if (value === '') {
      setGlobalPrefixVal('');
      checkDuplicatePrefix(''); // Clear any duplicate errors
      return;
    }

    // Apply different filtering rules based on isBundleTabPage
    let filteredValue;

    if (isBundleTabPage) {
      // For bundle tab page:
      // Allow only alphanumeric characters and dots
      filteredValue = value.replace(/[^A-Z0-9.]/g, '');

      // Check if first character is a letter (not a number or dot)
      if (filteredValue.length > 0 && !/^[A-Z]/.test(filteredValue)) {
        return; // Don't update if doesn't start with a letter
      }

      // Don't allow three or more consecutive letters (e.g., "AAA")
      if (/[A-Z]{3,}/.test(filteredValue)) {
        return; // Reject if 3 or more consecutive letters anywhere
      }

      // Don't allow a dot as the first character
      if (filteredValue.length === 1 && filteredValue === '.') {
        return;
      }

      // Don't allow consecutive dots
      if (
        filteredValue.endsWith('.') &&
        filteredValue.length > 1 &&
        filteredValue[filteredValue.length - 2] === '.'
      ) {
        return;
      }

      // Define the valid patterns explicitly:

      // 1. Single letter (A, B)
      const singleLetterPattern = /^[A-Z]$/;

      // 2. Double letters (AA, BB)
      const doubleLetterPattern = /^[A-Z]{2}$/;

      // 3. Single letter + 1-2 digits (A1, A99)
      const letterDigitPattern = /^[A-Z][0-9]{1,2}$/;

      // 4. Single letter + 1-2 digits + dot + 1-2 digits (A1.1, A99.99, A9.99, A99.9)
      const letterDigitDotDigitPattern = /^[A-Z][0-9]{1,2}\.[0-9]{1,2}$/;

      // Important: Do NOT allow AA1 pattern (2 letters + digit)
      // Adding explicit check to reject AA1 pattern
      if (/^[A-Z]{2}[0-9]/.test(filteredValue)) {
        return; // Reject patterns like AA1
      }

      // Check if the current value matches any of the valid patterns
      const isValidPattern =
        singleLetterPattern.test(filteredValue) ||
        doubleLetterPattern.test(filteredValue) ||
        letterDigitPattern.test(filteredValue) ||
        letterDigitDotDigitPattern.test(filteredValue);

      // Allow partial inputs that could be valid when completed
      const isIncompleteValidPattern =
        /^[A-Z]{1,2}$/.test(filteredValue) || // Partial letters (A, AA)
        /^[A-Z][0-9]{1,2}$/.test(filteredValue) || // Single letter + 1-2 digits (A1, A99)
        /^[A-Z][0-9]{1,2}\.?$/.test(filteredValue) || // Partial dot format (A1., A99.)
        /^[A-Z][0-9]{1,2}\.[0-9]{1}$/.test(filteredValue); // Single digit after dot (A1.1, A99.9)

      // Don't allow formats like AA.1 (two letters followed by dot)
      if (/^[A-Z]{2}\./.test(filteredValue)) {
        return;
      }

      // Reject the input if it doesn't match any valid pattern or incomplete pattern
      if (!isValidPattern && !isIncompleteValidPattern) {
        return;
      }
    } else {
      // For non-bundle tab page:
      // Allow only alphabetic characters (no dots or numbers)
      filteredValue = value.replace(/[^A-Z]/g, '');

      // Don't allow three or more letters
      if (filteredValue.length > 2) {
        return; // Don't update if more than 2 letters for non-bundle
      }
    }

    // Don't allow input to end with a dot
    if (filteredValue.endsWith('.') && !/^[A-Z][0-9]{1,2}\.$/.test(filteredValue)) {
      // Only allow the dot if it's in the pattern A1. or A99.
      return;
    }

    setGlobalPrefixVal(filteredValue);

    // Check for duplicates with debounce
    checkDuplicatePrefix(filteredValue);
  };
  const messageParams = {
    folder: folder && folder.name,
    containerType: isCustomContainers
      ? 'bundle'
      : titles.containerType === 'trialbook'
        ? 'trialbundle'
        : titles.containerType,
    ...((titles.message === 'case.moveABundleMessage' ||
      titles.message === 'case.removeABundleMessage') && {
      containerName:
        isCustomContainers && containers
          ? titles.toContainerName === T.translate('case.courtBundles')
            ? formatLabel(containers[1])
            : formatLabel(containers[0])
          : titles.toContainerName,
    }),
    ...(titles.message === 'case.removeFromGroupBundlesMessage' && {
      containerName: titles.containerName,
    }),
  };
  const translatedMessage = titles.message ? T.translate(titles.message, messageParams) : '';
  return (
    <>
      <Modal
        show={show}
        loadingBtn={saving}
        disableClose={reindexConflict}
        title={T.translate(titles.title, {
          containerType: isCustomContainers
            ? 'bundle'
            : titles.containerType === 'trialbook'
              ? 'trial bundle'
              : titles.containerType,
          ...((action === folderModalActions.healthCheck ||
            action === folderModalActions.clone ||
            folderModalActions.reposition) &&
            folder && { folderName: folder.name }),
        })}
        handleClose={() => {
          setShowGlobalPaging(globalPaging);
          setGlobalPrefixVal(globalPagePrefix);
          handleClose();
        }}
        handleSave={
          titles.saveTitle &&
          handleSubmit((data) => {
            let payload = { ...data, pipelineVersion };
            if (action === folderModalActions.reIndex) {
              const { cascade, ...rest } = payload || {};
              payload = {
                ...rest,
                nonCascading: cascade === false,
              };
              const promise = handleSave({ ...payload, enablePipelineCheck: true }, action, folder);
              if (promise && typeof promise.then === 'function') {
                promise
                  .then(() => {
                    setReindexConflict(false);
                    handleClose();
                  })
                  .catch(() => {
                    setReindexConflict(true); // keep open
                  });
              } else {
                handleClose();
              }
            } else if (action === folderModalActions.bulkUpdateFiles) {
              // Build a clean payload: only include fields the user actively set
              const bulkFields = isBulkDateOnlyMode
                ? ['docDate', 'docTime']
                : [
                    'docDate',
                    'docTime',
                    'discoveryId',
                    'externalId',
                    'disclosureId',
                    'familyId',
                    'description',
                  ];
              const cleanPayload = { pipelineVersion };
              bulkFields.forEach((field) => {
                // Skip fields that have a copy-from mapping or clear toggle
                if (
                  fieldMappings[field] ||
                  clearFields[field] ||
                  (copyFromPrimaryDate && field === 'docDate')
                )
                  return;
                // Only include if user actually entered a value
                if (payload[field] !== undefined && payload[field] !== '') {
                  cleanPayload[field] = payload[field];
                }
              });
              // Handle cleared fields — send empty string
              Object.entries(clearFields).forEach(([field, cleared]) => {
                if (cleared && bulkFields.includes(field)) {
                  cleanPayload[field] = '';
                }
              });
              // Handle field mappings
              const mappingsArray = Object.entries(fieldMappings)
                .filter(([toField]) => bulkFields.includes(toField))
                .map(([toField, fromField]) => ({
                  fromField,
                  toField,
                }));
              if (copyFromPrimaryDate) {
                mappingsArray.push({ fromField: 'primaryDate', toField: 'docDate' });
              }
              if (mappingsArray.length > 0) {
                cleanPayload.fieldMappings = mappingsArray;
              }
              setPendingBulkPayload(cleanPayload);
              setShowBulkConfirmation(true);
            } else if (action === folderModalActions.updateExhibitNumbers) {
              setSaving(true);
              const promise = handleSave(payload, action, folder);
              if (promise && typeof promise.then === 'function') {
                promise
                  .then(() => {
                    setSaving(false);
                    handleClose();
                  })
                  .catch(() => {
                    setSaving(false);
                  });
              } else {
                setSaving(false);
                handleClose();
              }
            } else {
              handleSave(payload, action, folder);
              handleClose();
            }
          })
        }
        footerLeftContent={action === folderModalActions.deleteAll ? undefined : translatedMessage}
        saveTitle={T.translate(titles.saveTitle)}
        disableSave={
          !!duplicatePrefixError ||
          (action === folderModalActions.classify && !watchedClassifyType) ||
          (action === folderModalActions.reIndex && valuesHaveNotBeenSelected) ||
          (action === folderModalActions.bulkUpdateFiles &&
            (!hasAnyBulkUpdateField || isBulkDateInvalid || isBulkTimeInvalid)) ||
          (action === folderModalActions.updateExhibitNumbers &&
            (!isExhibitPrefixValid || !isExhibitStartNumberValid)) ||
          (action === folderModalActions.deleteAll && !canDeleteAllAllowed) ||
          saving
        }
      >
        {action === folderModalActions.deleteAll && translatedMessage && (
          <div style={{ marginBottom: '1rem', whiteSpace: 'pre-wrap' }}>{translatedMessage}</div>
        )}
        <FormProvider {...methods}>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
            }}
            hidden={
              ![
                folderModalActions.createTeamBundle,
                folderModalActions.createPrivateBundle,
                folderModalActions.createBundle,
                folderModalActions.updateBundle,
                folderModalActions.createTrialbook,
                folderModalActions.updateTrialbook,
                folderModalActions.createTimeline,
                folderModalActions.updateTimeline,
                folderModalActions.createTag,
                folderModalActions.updateTag,
                folderModalActions.reIndex,
                folderModalActions.classify,
                folderModalActions.clone,
                folderModalActions.convertToBundle,
                folderModalActions.shareWithGroup,
                folderModalActions.exportFolder,
                folderModalActions.bulkUpdateFiles,
                folderModalActions.updateExhibitNumbers,
              ].includes(action)
            }
          >
            <Form.Group style={{ margin: '0.5rem' }}>
              {action !== folderModalActions.reIndex &&
                action !== folderModalActions.classify &&
                action !== folderModalActions.exportFolder &&
                action !== folderModalActions.shareWithGroup &&
                action !== folderModalActions.bulkUpdateFiles &&
                action !== folderModalActions.updateExhibitNumbers && (
                  <Row>
                    <Col>
                      <TextForm
                        {...register('name', { required: true, pattern: validation.folder })}
                        label={formLabelHandler()}
                        placeholder={formPlaceholderHandler()}
                        defaultValue={folder && folder.name}
                        readOnly={[
                          folderModalActions.agreeTrialbook,
                          folderModalActions.deleteTrialbook,
                          folderModalActions.deleteBundle,
                          folderModalActions.deleteAll,
                          folderModalActions.share,
                          folderModalActions.deleteTimeline,
                          folderModalActions.deleteTag,
                          folderModalActions.burnCrossRef,
                          folderModalActions.reIndex,
                          folderModalActions.classify,
                        ].includes(action)}
                        errors={errors}
                        autofocus
                      />
                    </Col>
                  </Row>
                )}
              {action === folderModalActions.bulkUpdateFiles && (
                <>
                  <Form.Group style={{ marginBottom: '1rem' }}>
                    <Form.Label>{T.translate('case.dateWithFormat')}</Form.Label>
                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                      <div style={{ flex: '0 0 20%', display: 'flex', alignItems: 'center' }}>
                        <Controller
                          name={'docDate'}
                          control={control}
                          rules={{
                            validate: {
                              isValidDate: (val) => {
                                if (!val) return true;
                                return moment(val, 'DD/MM/YYYY', true).isValid();
                              },
                            },
                            required: getValues('docTime')
                              ? T.translate('case.dateRequiredMsg')
                              : false,
                          }}
                          render={({ field }) => (
                            <DateInput
                              {...field}
                              placeholder={T.translate('case.datePlaceholder')}
                              errors={errors}
                              disabled={copyFromPrimaryDate || !!clearFields.docDate}
                            />
                          )}
                        />
                      </div>
                      <div style={{ flex: '0 0 15%', display: 'flex', alignItems: 'center' }}>
                        <Controller
                          name={'docTime'}
                          control={control}
                          rules={{
                            validate: {
                              isValidTime: (val) => {
                                if (!val) return true;
                                return moment(val, 'HH:mm:ss', true).isValid();
                              },
                            },
                          }}
                          render={({ field }) => (
                            <TimeInput
                              {...field}
                              placeholder={T.translate('case.timePlaceholder')}
                              errors={errors}
                              disabled={copyFromPrimaryDate || !!clearFields.docDate}
                            />
                          )}
                        />
                      </div>
                      <FormControlLabel
                        control={
                          <Switch
                            size="small"
                            checked={copyFromPrimaryDate}
                            disabled={!!clearFields.docDate}
                            onChange={(e) => {
                              setCopyFromPrimaryDate(e.target.checked);
                              if (e.target.checked) {
                                setValue('docDate', '');
                                setValue('docTime', '');
                              }
                            }}
                          />
                        }
                        label={T.translate('case.copyFromPrimaryDate')}
                        sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            size="small"
                            checked={!!clearFields.docDate}
                            disabled={copyFromPrimaryDate}
                            onChange={(e) => {
                              handleClearFieldToggle('docDate', e.target.checked);
                              if (e.target.checked) {
                                setCopyFromPrimaryDate(false);
                                setValue('docTime', '');
                              }
                            }}
                          />
                        }
                        label={T.translate('case.clearExistingValue')}
                        sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }}
                      />
                    </div>
                  </Form.Group>
                  {!isBulkDateOnlyMode && (
                    <>
                      <Form.Group style={{ marginBottom: '1rem' }}>
                        <Form.Label>{T.translate('case.discoveryId')}</Form.Label>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                          <div style={{ flex: '0 0 28%' }}>
                            <TextForm
                              {...register('discoveryId')}
                              placeholder={T.translate('case.discoveryIdPlaceholder')}
                              disabled={!!fieldMappings.discoveryId || !!clearFields.discoveryId}
                            />
                          </div>
                          <FormControl
                            size="small"
                            disabled={!!clearFields.discoveryId}
                            sx={{ flex: '0 0 18%', '& .MuiInputBase-root': { height: '38px' } }}
                          >
                            <InputLabel>{T.translate('case.copyFrom')}</InputLabel>
                            <MuiSelect
                              value={fieldMappings.discoveryId || ''}
                              label={T.translate('case.copyFrom')}
                              onChange={(e) => {
                                handleCopyFromChange('discoveryId', e.target.value);
                                if (e.target.value) setValue('discoveryId', '');
                              }}
                            >
                              <MenuItem value="">
                                <em>{T.translate('generic.none')}</em>
                              </MenuItem>
                              {copyFromOptions
                                .filter((opt) => opt.value !== 'discoveryId')
                                .map((opt) => (
                                  <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </MenuItem>
                                ))}
                            </MuiSelect>
                          </FormControl>
                          <FormControlLabel
                            control={
                              <Switch
                                size="small"
                                checked={!!clearFields.discoveryId}
                                disabled={!!fieldMappings.discoveryId}
                                onChange={(e) =>
                                  handleClearFieldToggle('discoveryId', e.target.checked)
                                }
                              />
                            }
                            label={T.translate('case.clearExistingValue')}
                            sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }}
                          />
                        </div>
                      </Form.Group>
                      <Form.Group style={{ marginBottom: '1rem' }}>
                        <Form.Label>{T.translate('case.externalId')}</Form.Label>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                          <div style={{ flex: '0 0 28%' }}>
                            <TextForm
                              {...register('externalId')}
                              placeholder={T.translate('case.externalIdPlaceholder')}
                              disabled={!!fieldMappings.externalId || !!clearFields.externalId}
                            />
                          </div>
                          <FormControl
                            size="small"
                            disabled={!!clearFields.externalId}
                            sx={{ flex: '0 0 18%', '& .MuiInputBase-root': { height: '38px' } }}
                          >
                            <InputLabel>{T.translate('case.copyFrom')}</InputLabel>
                            <MuiSelect
                              value={fieldMappings.externalId || ''}
                              label={T.translate('case.copyFrom')}
                              onChange={(e) => {
                                handleCopyFromChange('externalId', e.target.value);
                                if (e.target.value) setValue('externalId', '');
                              }}
                            >
                              <MenuItem value="">
                                <em>{T.translate('generic.none')}</em>
                              </MenuItem>
                              {copyFromOptions
                                .filter((opt) => opt.value !== 'externalId')
                                .map((opt) => (
                                  <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </MenuItem>
                                ))}
                            </MuiSelect>
                          </FormControl>
                          <FormControlLabel
                            control={
                              <Switch
                                size="small"
                                checked={!!clearFields.externalId}
                                disabled={!!fieldMappings.externalId}
                                onChange={(e) =>
                                  handleClearFieldToggle('externalId', e.target.checked)
                                }
                              />
                            }
                            label={T.translate('case.clearExistingValue')}
                            sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }}
                          />
                        </div>
                      </Form.Group>
                      <Form.Group style={{ marginBottom: '1rem' }}>
                        <Form.Label>{T.translate('case.disclosureId')}</Form.Label>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                          <div style={{ flex: '0 0 28%' }}>
                            <TextForm
                              {...register('disclosureId')}
                              placeholder={T.translate('case.disclosureIdPlaceholder')}
                              disabled={!!fieldMappings.disclosureId || !!clearFields.disclosureId}
                            />
                          </div>
                          <FormControl
                            size="small"
                            disabled={!!clearFields.disclosureId}
                            sx={{ flex: '0 0 18%', '& .MuiInputBase-root': { height: '38px' } }}
                          >
                            <InputLabel>{T.translate('case.copyFrom')}</InputLabel>
                            <MuiSelect
                              value={fieldMappings.disclosureId || ''}
                              label={T.translate('case.copyFrom')}
                              onChange={(e) => {
                                handleCopyFromChange('disclosureId', e.target.value);
                                if (e.target.value) setValue('disclosureId', '');
                              }}
                            >
                              <MenuItem value="">
                                <em>{T.translate('generic.none')}</em>
                              </MenuItem>
                              {copyFromOptions
                                .filter((opt) => opt.value !== 'disclosureId')
                                .map((opt) => (
                                  <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </MenuItem>
                                ))}
                            </MuiSelect>
                          </FormControl>
                          <FormControlLabel
                            control={
                              <Switch
                                size="small"
                                checked={!!clearFields.disclosureId}
                                disabled={!!fieldMappings.disclosureId}
                                onChange={(e) =>
                                  handleClearFieldToggle('disclosureId', e.target.checked)
                                }
                              />
                            }
                            label={T.translate('case.clearExistingValue')}
                            sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }}
                          />
                        </div>
                      </Form.Group>
                      <Form.Group style={{ marginBottom: '1rem' }}>
                        <Form.Label>{T.translate('case.familyId')}</Form.Label>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                          <div style={{ flex: '0 0 28%' }}>
                            <TextForm
                              {...register('familyId')}
                              placeholder={T.translate('case.familyIdPlaceholder')}
                              disabled={!!fieldMappings.familyId || !!clearFields.familyId}
                            />
                          </div>
                          <FormControl
                            size="small"
                            disabled={!!clearFields.familyId}
                            sx={{ flex: '0 0 18%', '& .MuiInputBase-root': { height: '38px' } }}
                          >
                            <InputLabel>{T.translate('case.copyFrom')}</InputLabel>
                            <MuiSelect
                              value={fieldMappings.familyId || ''}
                              label={T.translate('case.copyFrom')}
                              onChange={(e) => {
                                handleCopyFromChange('familyId', e.target.value);
                                if (e.target.value) setValue('familyId', '');
                              }}
                            >
                              <MenuItem value="">
                                <em>{T.translate('generic.none')}</em>
                              </MenuItem>
                              {copyFromOptions
                                .filter((opt) => opt.value !== 'familyId')
                                .map((opt) => (
                                  <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </MenuItem>
                                ))}
                            </MuiSelect>
                          </FormControl>
                          <FormControlLabel
                            control={
                              <Switch
                                size="small"
                                checked={!!clearFields.familyId}
                                disabled={!!fieldMappings.familyId}
                                onChange={(e) =>
                                  handleClearFieldToggle('familyId', e.target.checked)
                                }
                              />
                            }
                            label={T.translate('case.clearExistingValue')}
                            sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }}
                          />
                        </div>
                      </Form.Group>
                      <Form.Group style={{ marginBottom: '1rem' }}>
                        <Form.Label>{T.translate('case.description')}</Form.Label>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                          <div style={{ flex: '0 0 28%' }}>
                            <TextForm
                              {...register('description')}
                              multiline
                              placeholder={T.translate('case.descriptionPlaceholder')}
                              disabled={!!fieldMappings.description || !!clearFields.description}
                            />
                          </div>
                          <FormControl
                            size="small"
                            disabled={!!clearFields.description}
                            sx={{ flex: '0 0 18%', '& .MuiInputBase-root': { height: '38px' } }}
                          >
                            <InputLabel>{T.translate('case.copyFrom')}</InputLabel>
                            <MuiSelect
                              value={fieldMappings.description || ''}
                              label={T.translate('case.copyFrom')}
                              onChange={(e) => {
                                handleCopyFromChange('description', e.target.value);
                                if (e.target.value) setValue('description', '');
                              }}
                            >
                              <MenuItem value="">
                                <em>{T.translate('generic.none')}</em>
                              </MenuItem>
                              {copyFromOptions
                                .filter((opt) => opt.value !== 'description')
                                .map((opt) => (
                                  <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </MenuItem>
                                ))}
                            </MuiSelect>
                          </FormControl>
                          <FormControlLabel
                            control={
                              <Switch
                                size="small"
                                checked={!!clearFields.description}
                                disabled={!!fieldMappings.description}
                                onChange={(e) =>
                                  handleClearFieldToggle('description', e.target.checked)
                                }
                              />
                            }
                            label={T.translate('case.clearExistingValue')}
                            sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }}
                          />
                        </div>
                      </Form.Group>
                    </>
                  )}
                </>
              )}
              {action === folderModalActions.updateExhibitNumbers && (
                <>
                  <Row>
                    <Col>
                      <Controller
                        name={'exhibitPrefix'}
                        control={control}
                        defaultValue={referencePrefix || ''}
                        rules={{ required: true, pattern: /^[A-Z]{1,3}$/ }}
                        render={({ field }) => (
                          <TextForm
                            {...field}
                            label={T.translate('case.exhibitPrefix')}
                            placeholder={T.translate('case.exhibitPrefixPlaceholder')}
                            errors={errors}
                            onChange={(e) => {
                              const filteredValue = e.target.value
                                .toUpperCase()
                                .replace(/[^A-Z]/g, '')
                                .slice(0, 3);
                              field.onChange(filteredValue);
                            }}
                            value={field.value || ''}
                          />
                        )}
                      />
                    </Col>
                    <Col>
                      <Controller
                        name={'exhibitStartNumber'}
                        control={control}
                        defaultValue={1}
                        rules={{ required: true, min: 0 }}
                        render={({ field }) => (
                          <TextForm
                            {...field}
                            label={T.translate('case.exhibitStartNumber')}
                            placeholder={T.translate('case.exhibitStartNumberPlaceholder')}
                            type="number"
                            errors={errors}
                            onChange={(e) => {
                              const nextValue = e.target.value;
                              if (nextValue === '') {
                                field.onChange('');
                                return;
                              }
                              const parsedValue = Number(nextValue);
                              if (!Number.isNaN(parsedValue)) {
                                field.onChange(Math.max(0, parsedValue));
                              }
                            }}
                            value={field.value === 0 ? 0 : field.value || ''}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <ToggleForm
                        {...register('overwriteExistingReferences')}
                        label={T.translate('case.overwriteExistingReferences')}
                        defaultValue={overwriteExistingReferences}
                      />
                    </Col>
                    <Col
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                      }}
                    >
                      {overwriteExistingReferences && (
                        <div
                          className="text-danger"
                          style={{ fontSize: '0.9rem', fontWeight: 600 }}
                        >
                          {T.translate('case.updateExhibitNumbersWarning')}
                        </div>
                      )}
                    </Col>
                  </Row>
                </>
              )}
              {folder &&
                (folder.level === 0 || folder.level === 1) &&
                (action === folderModalActions.updateTrialbook ||
                  action === folderModalActions.updateBundle) && (
                  <>
                    {isAgreeTrialbook &&
                      folder &&
                      (folder.level === 0 || folder.level === 1) &&
                      !folder.readOnly && (
                        <Row>
                          <Col>
                            <ToggleForm
                              {...register('agreed', {
                                onChange: (e) => handleWarning(e.target.checked),
                              })}
                              label={T.translate('case.lockDown')}
                              rightAdornment={
                                <Tooltip
                                  arrow
                                  placement="top"
                                  title={T.translate('case.lockDownInfo')}
                                >
                                  <InfoIcon style={{ color: '#7BA0F4' }} />
                                </Tooltip>
                              }
                              defaultValue={agreed}
                              disabled={agreed && !isUnAgreeTrialbook}
                            />
                          </Col>
                          <Col />
                          {showWarning && (
                            <span className="agree-warning">
                              {T.translate('case.agreeTrialbookWarning')}
                            </span>
                          )}
                        </Row>
                      )}
                    <Row>
                      <Col>
                        <ToggleForm
                          {...register('predictiveIndex')}
                          label={T.translate('case.predictiveIndex')}
                          rightAdornment={
                            <Tooltip
                              arrow
                              placement="top"
                              title={T.translate('case.predictiveIndexInfo')}
                            >
                              <InfoIcon style={{ color: '#7BA0F4' }} />
                            </Tooltip>
                          }
                          defaultValue={predictiveIndex}
                        />
                      </Col>
                      <Col />
                    </Row>
                    {folder && folder.folders && folder.folders.length > 0 && (
                      <Row>
                        <Col>
                          <ToggleForm
                            {...register('generateIndexFolder')}
                            label={T.translate('case.generateIndexFolder')}
                            rightAdornment={
                              <Tooltip
                                arrow
                                placement="top"
                                title={T.translate('case.generateIndexFolder')}
                              >
                                <InfoIcon style={{ color: '#7BA0F4' }} />
                              </Tooltip>
                            }
                            defaultValue={generateIndexFolder}
                          />
                        </Col>
                        <Col />
                      </Row>
                    )}
                    <Row>
                      <Col>
                        <ToggleForm
                          {...register('zeroBasedIndex')}
                          label={T.translate('case.zeroBasedIndex')}
                          rightAdornment={
                            <Tooltip
                              arrow
                              placement="top"
                              title={T.translate('case.zeroBasedIndexTooltip')}
                            >
                              <InfoIcon style={{ color: '#7BA0F4' }} />
                            </Tooltip>
                          }
                          defaultValue={zeroBasedIndex}
                        />
                      </Col>
                      <Col />
                    </Row>
                    <Row>
                      <Col>
                        <ToggleForm
                          {...register('globalPaging', {
                            onChange: () => setShowGlobalPaging(!showGlobalPaging),
                          })}
                          label={
                            isBundleTabPage
                              ? T.translate('generic.bundleTabPaging')
                              : T.translate('generic.globalPaging')
                          }
                          rightAdornment={
                            <Tooltip
                              arrow
                              placement="top"
                              title={T.translate('generic.globalPagingTooltip')}
                            >
                              <InfoIcon style={{ color: '#7BA0F4' }} />
                            </Tooltip>
                          }
                          defaultValue={showGlobalPaging}
                          disabled={!enableGP}
                        />
                      </Col>
                      <Col />
                    </Row>
                    {showGlobalPaging && (
                      <Row>
                        <Col>
                          <TextForm
                            {...register('globalPagePrefix', {
                              onChange: handleGlobalPrefixChange,
                            })}
                            label={
                              isBundleTabPage
                                ? T.translate('case.bundlePrefix')
                                : T.translate('case.globalPagePrefix')
                            }
                            value={globalPrefixVal}
                            disabled={!enableGP}
                          />
                          {duplicatePrefixError && (
                            <div style={{ color: 'red', marginTop: '5px', fontSize: '0.875rem' }}>
                              {duplicatePrefixError}
                            </div>
                          )}
                        </Col>
                        <Col />
                        <Col />
                      </Row>
                    )}
                    <Row>
                      {!enableGP && (
                        <Col>
                          {folder.level === 0
                            ? T.translate('case.diableGPFieldMsgLevel0')
                            : T.translate('case.diableGPFieldMsgLevel1')}
                        </Col>
                      )}
                    </Row>
                  </>
                )}
              {action === folderModalActions.reIndex && (
                <>
                  {reindexConflict && (
                    <div style={{ color: 'var(--danger, #d32f2f)', margin: '0 0 0.5rem 0' }}>
                      {T.translate('feedback.reIndexBundleConflict')}
                    </div>
                  )}
                  <NewReindexContent
                    setValuesHaveNotBeenSelected={setValuesHaveNotBeenSelected}
                    show={show}
                  />
                </>
              )}
              {action === folderModalActions.classify && (
                <>
                  {pipelineVersion === 2 && (
                    <ClassifyContent
                      control={control}
                      errors={errors}
                      classifyFolderToOptions={classifyFolderToOptions}
                      classifyFolderType={classifyFolderType}
                      setClassifyFolderType={setClassifyFolderType}
                    />
                  )}
                </>
              )}
              {action === folderModalActions.exportFolder && (
                <div>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                      <span>{T.translate(`case.exportFolderMessage`)}</span>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <ToggleForm
                        {...register('useTrialBundleTabs')}
                        label={T.translate('case.useTrialBundleTabs')}
                        defaultValue={false}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                        labelStyle={{ marginRight: '8px', flex: '0 0 auto' }}
                      />
                    </Grid>
                    <Grid item xs={8}></Grid>
                  </Grid>
                </div>
              )}
              {action === folderModalActions.clone && (
                <>
                  <Grid container>
                    <Grid item xs={6}>
                      <SelectForm
                        name="cloneType"
                        label={T.translate(`case.cloneOption`)}
                        options={[
                          {
                            label: T.translate(`case.cloneStructureOnly`),
                            value: 'structureonly',
                          },
                          {
                            label: T.translate(`case.cloneStructureAndFiles`),
                            value: 'filesAndStructure',
                          },
                          {
                            label: T.translate(`case.cloneFilesOnly`),
                            value: 'filesonly',
                          },
                        ]}
                        control={control}
                        errors={errors}
                        rules={{ required: true }}
                        menuPosition="fixed"
                        onChange={(val) => setCloneOptionType(val)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container style={{ paddingTop: 5 }}>
                    <Grid item xs={6}>
                      <SelectForm
                        name="type"
                        onChange={(val) => setCloneFolderType(val)}
                        label={T.translate(`case.cloneFolderType`)}
                        options={[
                          // {
                          //   label: T.translate(`case.cloneIntoOptions.trialBundles`),
                          //   value: 'trialbook',
                          // },
                          {
                            label: T.translate(`case.cloneIntoOptions.teamBundles`),
                            value: 'team-bundle',
                          },
                          {
                            label: T.translate(`case.cloneIntoOptions.privateBundles`),
                            value: 'private-bundle',
                          },
                        ]}
                        control={control}
                        errors={errors}
                        rules={{ required: true }}
                        menuPosition="fixed"
                      />
                    </Grid>
                  </Grid>
                  <Grid container style={{ paddingTop: 5 }}>
                    <Grid item xs={6}>
                      <SelectForm
                        name="parentFolderId"
                        label={T.translate(`case.cloneToFolder`)}
                        valueKey="id"
                        labelKey="name"
                        options={cloneFolderToOptions}
                        cloneOptionType={cloneOptionType}
                        control={control}
                        errors={errors}
                        menuPosition="fixed"
                        readOnly={!cloneFolderType}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              {action === folderModalActions.shareWithGroup && (
                <Grid container sx={{ mb: '1rem' }}>
                  <Grid item xs={6}>
                    <SelectForm
                      name="groupId"
                      label={T.translate('case.selectGroup')}
                      valueKey="id"
                      labelKey="name"
                      //autofocus
                      defaultValue={''}
                      options={groupOptions || []}
                      control={control}
                      errors={errors}
                      rules={{ required: true }}
                      menuPosition="fixed"
                    />
                  </Grid>
                </Grid>
              )}
            </Form.Group>
          </Form>
        </FormProvider>
        <div>
          {action === folderModalActions.showHistory && (
            <FilterProvider>
              <HistoryInfo
                {...folder}
                pending={getMoreInfoFolderPending}
                data={moreInfoFolder}
                folder={folder}
              />
            </FilterProvider>
          )}
        </div>

        {(action === folderModalActions.removeFromTrialBooks ||
          action === folderModalActions.removeFromCourtBundles) &&
          teamId !== folderCreatedByTeamId && (
            <span>
              {T.translate('case.removeFromBundleNote', {
                createdByTeamName: folderCreatedByTeamName,
              })}
            </span>
          )}
        {action === folderModalActions.healthCheck && (
          <div style={{ margin: '-1.5rem' }}>
            <PerfectScrollbar options={{ suppressScrollX: true }} style={{ maxHeight: '45rem' }}>
              <HealthCheckModal folderId={folder.id} />
            </PerfectScrollbar>
          </div>
        )}
      </Modal>
      {action === folderModalActions.reposition && !folder.readOnly && !folder.agreed && (
        <RepositionModal
          handleClose={handleClose}
          show={action === folderModalActions.reposition}
          folder={folder}
        />
      )}
      <Dialog open={showBulkConfirmation} onClose={() => setShowBulkConfirmation(false)}>
        <DialogTitle>{T.translate('case.bulkUpdateConfirmTitle')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{T.translate('case.bulkUpdateConfirmMessage')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowBulkConfirmation(false)}>
            {T.translate('case.cancel')}
          </Button>
          <Button onClick={handleBulkUpdateWithoutExport} variant="outlined">
            {T.translate('case.bulkUpdateWithoutExport')}
          </Button>
          <Button onClick={handleBulkExportAndUpdate} variant="contained">
            {T.translate('case.bulkUpdateExportAndUpdate')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

FolderModal.propTypes = {};
FolderModal.defaultProps = {};
